import { render } from "./ChangeAffinity.vue?vue&type=template&id=50226cd8&scoped=true"
import script from "./ChangeAffinity.vue?vue&type=script&lang=js"
export * from "./ChangeAffinity.vue?vue&type=script&lang=js"

import "./ChangeAffinity.vue?vue&type=style&index=0&id=50226cd8&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50226cd8"]])

export default __exports__